import { Component, OnInit,ViewChild, ElementRef } from '@angular/core';
import { Table } from 'primeng/table';
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { LazyLoadEvent } from 'primeng/api';
import { Dropdown } from "primeng/dropdown";
import { environment } from 'src/environments/environment';
import * as moment from "moment";
import { saveAs } from 'file-saver/src/FileSaver';
@Component({
  selector: 'app-tds-data',
  templateUrl: './tds-data.component.html',
  styleUrls: ['./tds-data.component.scss'],
  styles: [`
        :host ::ng-deep .p-datatable-gridlines p-progressBar {
            width: 100%;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})
export class TdsDataComponent implements OnInit {
         public hide: boolean = true;
  errorMessage = '';
  statuses: any[];
  searchBy: any[];
  rowGroupMetadata: any;
  totalRecords: 0;
  virtualDatabase: any;
  userlist: any;
  adminRoleId;
  userdetail: any;
  public item: any[] = [];
  genders: any = [];
  loading: boolean;
  paginationOption;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  calvalue: Date;
  ucalvalue: Date;
  dcalvalue: Date;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  downloadUserList: any;
  searchby;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  constructor(private el: ElementRef, private titlecasePipe: TitleCasePipe, private router: Router, private route: ActivatedRoute, private messageService: MessageService, private confirmationService: ConfirmationService) { }



  ngOnInit(): void {
    this.paginationOption = environment.pagination;
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];
     this.searchBy = [
        { label: "Created On", value: "created_at" },
      ];

    this.downloadFlg = false;
    //this.getUserlist();
  }

  loadUsers(event: LazyLoadEvent) {
      this.lastTableLazyLoadEvent = event;
      var query = "?filterByDisable=false";
      var pagenumber = 1;
      var params = "";
      var rows;

      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }

      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }

      if (event.filters != undefined && event.filters["TDSSection"] != undefined) {
        params += "&filterByclientGSTIN=" + event.filters["TDSSection"].value;
      }
      if (event.filters != undefined && event.filters["permannentAccountNumber"] != undefined) {
        params += "&filterByclientLegalName=" + event.filters["permannentAccountNumber"].value;
      }

      if (this.searchby && this.startDate && this.endDate) {
        params += "&filterByDate=" + this.searchby.value;
        params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
        params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
      }

      if (this.downloadFlg == false) {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
        if (params) query += params;
      } else {
        if (params) query += params;
      }
    }

   // changeStatus(user) {
  //   this.confirmationService.confirm({
  //     message: 'Are you sure you want to change the status of  ' + (this.titlecasePipe.transform(user.fullName)) + '?',
  //     header: 'Confirm',
  //     icon: 'pi pi-exclamation-triangle',
  //     accept: () => {

  //       var userData = '{"status":' + user.status + '}';
  //       this.userService.updateUser(user.id, userData).subscribe(
  //         data => {
  //           this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Admin Status Updated', life: 3000 });
  //           this.getUserDetails(user.id);
  //         },
  //         err => {
  //           this.errorMessage = err.error.message;
  //         }
  //       );
  //     },
  //     reject: () => {
  //       this.getUserDetails(user.id);
  //     }
  //   });
  // }
   // getUserDetails(id) {
  //   this.userService.getUserDetails(id).subscribe(
  //     data => {
  //       this.userdetail = data;
  //       this.userdetail.created_at = new Date(this.userdetail.created_at);
  //       this.userdetail.name = this.userdetail.firstName + ' ' + this.userdetail.lastName;
  //       if (this.userdetail.status == "true") {
  //         this.userdetail.statusactive = true;
  //       } else {
  //         this.userdetail.statusactive = false;
  //       }
  //       this.userlist[this.findIndexById(id)] = this.userdetail;
  //     },
  //     err => {
  //       this.errorMessage = err.error.message;
  //     }
  //   );
  // }
 addColumns() {
        this.hide = false;

    }

    /**
    * Use to remove more columns in the table.
    */
    removeColumns() {
        this.hide = true;
    }
  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadUsers(this.lastTableLazyLoadEvent);
    var propertiesRemove = ['id', 'role', 'profilepic', 'createdby', 'updatedby', 'disable', 'countrycode', 'statecode', 'created_at', 'updated_at'];
    this.downloadUserList = this.userlist;
    this.downloadUserList.forEach(function (item) {
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.downloadUserList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, "GSTSalesData");
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

}
